module.exports = "/images/1cab60f3758460726d0d9378658b31e1.png";